import React from "react"
import { Card, CardBody, Col } from "reactstrap"
import Chart from "react-apexcharts"
import PropTypes from "prop-types"

const WaveChart = ({ title, labels, tooltipLabels, series, statName }) => {
    const options = {
        chart: {
            type: "area",
            toolbar: { show: false },
            zoom: { enabled: false },
            foreColor: '#000', // <--- Sets X and Y axis text to White
            fontFamily: 'inherit'
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        xaxis: {
            categories: labels,
            labels: { style: { fontSize: "12px" } },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        tooltip: {
            theme: "light", // <--- Forces the dark background for the tooltip box
            x: {
                formatter: (val, { dataPointIndex }) => {
                    if (tooltipLabels && tooltipLabels[dataPointIndex]) {
                        return tooltipLabels[dataPointIndex] || val
                    }
                    return val
                }
            }
        },
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.5,
                opacityTo: 0.1,
                stops: [0, 90, 100]
            }
        },
        colors: ["#FFCA5C"], // <--- Changed Blue to Gold
        legend: { show: false },
        grid: {
            borderColor: "#555", // <--- Darker grid lines to blend with background
            strokeDashArray: 4
        }
    }

    return (
        <Col xl={12}>
            {/* Added Background Color and removed border */}
            <Card style={{ backgroundColor: "#3C3C3C", border: "none" }}>
                <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Added text-white class */}
                        <h5 className="mb-0 text-white">{title}</h5>
                    </div>
                    <Chart
                        options={options}
                        series={[{ name: statName, data: series }]}
                        type="area"
                        height={250}
                    />
                </CardBody>
            </Card>
        </Col>
    )
}

WaveChart.propTypes = {
    title: PropTypes.string,
    labels: PropTypes.arrayOf(PropTypes.string),
    tooltipLabels: PropTypes.arrayOf(PropTypes.string),
    series: PropTypes.arrayOf(PropTypes.number),
    statName: PropTypes.string
}

export default WaveChart